<template>
  <div class="frmware-detail-device-table">
    <h2 class="table-title">
      {{ $t('dms_firmwareTask_detail_deviceTable.she_bei_xin_xi') }}
      <!-- <el-form-item > -->
        <search-input style="width: 260px;float: right;margin-top: 14px;" v-model="formSearch.search" :placeholder="$t('dms_firmwareTask_detail_deviceTable.ji_shen_haoModemSN')" @fetch="onPageChange({ page: 1 })"></search-input>
      <!-- </el-form-item> -->
    </h2>
    <div class="table-bd">
      <!-- 只有固件升级serviceType 3 才有进度 -->
      <custom-table
        v-if="`${serviceType}` !== '3'"
        :data="tableList"
        :loading="isLoading"
        :tableCode="tableCode"
        :index="true"
        :slots="['deviceMsg', 'returnContent', 'action']"
        @filter="filterChange"
        @sort="sortChange"
        :filterArr="['progress']"
        height="100%"
      >
        <template slot="deviceMsg" slot-scope="scope">
          <el-popover placement="top-start" trigger="hover">
            <ul>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.ye_wu_zhuang_tai') }}： {{ scope.row.bizState || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.shou_hou_gong_si') }}： {{ scope.row.afterServiceName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.dai_li_gong_si') }}： {{ scope.row.agentCoName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.zu_lin_fang') }}： {{ scope.row.customerName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.sbsydz') }}： {{ scope.row.useLocation || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.yuan_zi_yuan_ban_ben') }}： {{ scope.row.oldResourceVersion || '-' }}</li>
            </ul>
            <div class="cell-pop" slot="reference">{{ $t('Common.com_detail') }}</div>
          </el-popover>
        </template>
        <template slot="returnContent" slot-scope="scope">
          <el-popover placement="top-start" trigger="hover">
            <ul>
              <li class="cell-pop-item">{{ scope.row.returnContent }}</li>
            </ul>
            <div class="cell-pop" slot="reference" v-if="scope.row.returnContent">{{ $t('Common.com_detail') }}</div>
          </el-popover>
        </template>
        <template v-slot:progress="scope">
          <span>
            {{ getDicValue('iot_cmd_task_progress_type', scope.row.progressType) }} {{ scope.row.progressValue }}
            <span v-if="scope.row.progressValue">%</span>
          </span>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button v-if="scope.row.executeState === 3" type="text" size="mini" @click="onCancelRow(scope.row.taskDetailId)">{{ $t('Common.com_cancel') }}</el-button>
          <!-- <el-button v-if="scope.row.executeState===0||scope.row.executeState===4" type="text" size="mini" @click="onDeleteRow(scope.row.taskDetailId )">{{$t('com_delete}}</el-button> -->
        </template>
      </custom-table>
      <custom-table
        v-else
        :data="tableList"
        :loading="isLoading"
        :column="tableColumn"
        :index="true"
        :slots="['deviceMsg', 'returnContent', 'progress', 'action']"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
      >
        <template slot="deviceMsg" slot-scope="scope">
          <el-popover placement="top-start" trigger="hover">
            <ul>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.ye_wu_zhuang_tai') }}： {{ scope.row.bizState || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.shou_hou_gong_si') }}： {{ scope.row.afterServiceName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.dai_li_gong_si') }}： {{ scope.row.agentCoName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.zu_lin_fang') }}： {{ scope.row.customerName || '-' }}</li>
              <li class="cell-pop-item">{{ $t('dms_firmwareTask_detail_deviceTable.sbsydz') }}： {{ scope.row.useLocation || '-' }}</li>
            </ul>
            <div class="cell-pop" slot="reference">{{ $t('Common.com_detail') }}</div>
          </el-popover>
        </template>
        <template slot="returnContent" slot-scope="scope">
          <el-popover placement="top-start" trigger="hover">
            <ul>
              <li class="cell-pop-item">{{ scope.row.returnContent }}</li>
            </ul>
            <div class="cell-pop" slot="reference" v-if="scope.row.returnContent">{{ $t('Common.com_detail') }}</div>
          </el-popover>
        </template>
        <template v-slot:progress="scope">
          <span>
            {{ getDicValue('iot_cmd_task_progress_type', scope.row.progressType) }} {{ scope.row.progressValue }}
            <span v-if="scope.row.progressValue">%</span>
          </span>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button v-if="scope.row.executeState === 3" type="text" size="mini" @click="onCancelRow(scope.row.taskDetailId)">{{ $t('Common.com_cancel') }}</el-button>
          <!-- <el-button v-if="scope.row.executeState===0||scope.row.executeState===4" type="text" size="mini" @click="onDeleteRow(scope.row.taskDetailId )">{{$t('com_delete}}</el-button> -->
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTable from '@/components/customTable.vue';

export default {
  components: { customTable },
  props: {
    taskId: [String, Number],
    serviceType: [String, Number],
  },
  computed: {
    showProgress() {
      return `${this.serviceType}` === '3';
    },
  },

  data() {
    return {
      tableCode: 'firmware_task_device_detail',
      // 分页
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
        // 高级搜索
        // modemSn: '',
        // bodyNum: '',
        taskId: '',
      },
      tableList: [],
      isLoading: false,
      totalRows: null,
      progressFlagTimeOut: null,
    };
  },
  destroyed() {
    clearTimeout(this.progressFlagTimeOut);
    this.progressFlagTimeOut = null;
  },
  mounted() {
    this.getTableList();
    this.getTableColumn();
  },
  methods: {
    getTableList: function () {
      this.isLoading = true;
      this.formSearch.taskId = this.taskId;
      this.$getJSON(apis.commandTaskDetailPage, this.formSearch).then((res) => {
        this.isLoading = false;
        // 1. 赋值前保存旧数据
        const oldTableList = JSON.parse(JSON.stringify(this.tableList));
        this.tableList = res.data.list;
        // 3. 检查 executeState 是否变化
        const hasChanged = this.checkExecuteStateChange(oldTableList, this.tableList);

        this.totalRows = res.data.total;
        if (oldTableList.length && hasChanged) {
          // 进行中的个数更新了， 刷新info
          this.$emit('success');
        }

        // 检查升级进度
        this.cheackUpgrade();
      });
    },
    // 检查正在升级的进度
    cheackUpgrade() {
      if (this.tableList.length > 0) {
        // 执行中开关
        const progressFlag = this.tableList.some(i => i.executeState === 3);
        if (progressFlag) {
          this.progressFlagTimeOut = setTimeout(() => {
            this.getTableList();
          }, 3000);
        } else {
          clearTimeout(this.progressFlagTimeOut);
        }
      }
    },
    checkExecuteStateChange(oldList, newList) {
      if (oldList.length !== newList.length) {
        return true; // 如果长度不同，默认有变化
      }
      for (let i = 0; i < oldList.length; i++) {
        if (oldList[i].executeState !== newList[i].executeState) {
          return true; // 只要有一个不同，返回 true
        }
      }
      return false; // 全部相同，返回 false
    },


    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 取消
    onCancelRow: function (id) {
      this.$showConfirm(this.$t('dms_firmwareTask_detail_deviceTable.nqdyqxdqxzrwm'))
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailCancel}/${id}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 删除
    onDeleteRow: function (id) {
      this.$showConfirm(this.$t('dms_firmwareTask_detail_deviceTable.nqdyscdqxzrwm'))
        .then(() => {
          this.$postJSON(`${apis.commandTaskDetailDelete}/${id}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.frmware-detail-device-table{
  // margin-top: 20px;
  // display: flex;
  flex: 1;
    display: flex;
    flex-direction: column;
    //margin-bottom: 30px;
  .table-box {
    flex: 1;
    .table-title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }

    .table-bd {
      height: 100%;
    }
  }
}
</style>
